module.exports = __webpack_public_path__ + "img/bg.716b21be.png";